module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 1
// module chunks = 0